export default __webpack_public_path__ + "static/media/1873.06aa371d.png";